import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function addIllustrator(illustratorData) {
    const response = await apiFetch(API_ENDPOINTS.ILLUSTRATOR, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(illustratorData),
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dodavanja ilustratora");
    }

    return response.json();
}

export async function getAllIllustrators() {
    const response = await apiFetch(API_ENDPOINTS.ILLUSTRATOR);

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dohvaćanja ilustratora");
    }

    return response.json();
}

export async function getIllustratorById(id) {
    const response = await apiFetch(`${API_ENDPOINTS.ILLUSTRATOR}/${id}`);

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message || `Greška prilikom dohvaćanja ilustratora ID=${id}`
        );
    }

    return response.json();
}

export async function updateIllustrator(id, illustratorData) {
    const response = await apiFetch(`${API_ENDPOINTS.ILLUSTRATOR}/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(illustratorData),
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message || `Greška prilikom ažuriranja ilustratora ID=${id}`
        );
    }

    return response.json();
}

export async function deleteIllustrator(id) {
    const response = await apiFetch(`${API_ENDPOINTS.ILLUSTRATOR}/${id}`, {
        method: "DELETE",
        credentials: "include",
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message || `Greška prilikom brisanja ilustratora ID=${id}`
        );
    }

    return true;
}

export async function searchIllustrators(term) {
    const response = await apiFetch(
        `${API_ENDPOINTS.ILLUSTRATOR}/search?term=${encodeURIComponent(term)}`,
        {
            method: "GET",
            credentials: "include",
        }
    );

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message ||
            `Greška prilikom pretrage ilustratora po terminu: ${term}`
        );
    }

    return response.json();
}
